import { PaginatedResponse as PaginatedResponseT } from '@gorila-shared-ui/components';

export type PaginatedResponse<T> = PaginatedResponseT<T> & {
  summary?: SummaryItem[];
};

export interface SummaryItem {
  _id: string;
  count: number;
}

export interface IdName {
  _id: string;
  name: string;
}

export enum ApiEndpoint {
  gnpKmSeguros,
  core,
  monitoring,
}
